import type { FC } from 'react';
import type { IconProps } from './types';

const Bell: FC<IconProps> = ({ color = 'currentColor', size = 24, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      color={color}
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68945 20C8.44439 21.624 10.0903 22.75 11.9991 22.75C13.908 22.75 15.5539 21.624 16.3088 20H7.68945Z"
        fill="currentColor"
      />
      <path
        d="M16.6911 18.75H19.5629H19.5835C19.9283 18.75 20.2227 18.75 20.4555 18.7354C20.6821 18.7211 20.9529 18.6893 21.1996 18.5664C21.871 18.232 22.2492 17.5106 22.1547 16.7773L22.1303 16.6309L22.1039 16.5312C22.0356 16.3042 21.9113 16.1068 21.7973 15.9443C21.6682 15.7604 21.4922 15.5404 21.2868 15.2838L21.2504 15.2383L21.0815 15.0264C20.6164 14.445 20.4159 14.1939 20.2485 13.9346C19.713 13.1051 19.3817 12.1599 19.2817 11.1777C19.2504 10.8708 19.2504 10.5503 19.2504 9.80662V8.5V8.48202C19.2504 8.04075 19.2504 7.7822 19.2358 7.55859C19.0142 4.17862 16.3217 1.48638 12.9418 1.26465C12.7183 1.25 12.4596 1.25 12.0185 1.25H12.0004H11.9819C11.5408 1.25 11.2816 1.25 11.058 1.26465C7.67815 1.48641 4.98563 4.17864 4.76409 7.55859C4.75029 7.76927 4.75033 8.01084 4.75041 8.4071L4.75042 8.5V9.80566C4.75042 10.55 4.74946 10.8707 4.71819 11.1777C4.61813 12.1599 4.28683 13.1051 3.7514 13.9346C3.58398 14.1939 3.38349 14.445 2.91839 15.0264L2.74944 15.2383L2.74269 15.2467C2.52466 15.5193 2.33881 15.7516 2.20355 15.9443C2.08947 16.1069 1.96435 16.304 1.89593 16.5312L1.86956 16.6309C1.70086 17.4128 2.08422 18.2097 2.80023 18.5664C3.04696 18.6893 3.31781 18.7211 3.54437 18.7354C3.77719 18.75 4.07149 18.75 4.41627 18.75H4.43694H7.30884H8.83693H15.163H16.6911Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Bell;
